// @ts-nocheck
/** biome-ignore-all lint/complexity/noArguments: <> */
import { googleAds } from '@api/auth/config';
import type { VendorTracker } from '../useConversionTracker';
import { createVendorTracker } from './createVendorTracker';

declare global {
  interface Window {
    gtag?: () => void;
    dataLayer?: unknown[];
  }
}

const fireGtag = (sendTo: string, callback?: () => void) => {
  if (typeof window.gtag !== 'function') {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window?.dataLayer?.push(arguments);
    };
  }
  try {
    window.gtag('event', 'conversion', { send_to: sendTo, event_callback: callback });
  } catch (err) {
    console.error('[GoogleConversionTracker] gtag threw unexpectedly', err);
    callback?.();
  }
};

export const googleConversionTracker: VendorTracker = createVendorTracker({
  vendor: 'google',
  fire(vendorEventName, callback) {
    const conversionId = googleAds.conversionId;
    if (!conversionId) {
      console.warn('[GoogleConversionTracker] GOOGLE_ADS_CONVERSION_ID is not configured — skipping');
      callback?.();
      return;
    }
    fireGtag(`${conversionId}/${vendorEventName}`, callback);
  },
});
